<template>
  <div class="ecop-ai-page">
    <div class="container">
      <div class="ecop-ai-page_title" data-aos="fade-up">
        <div class="font-size-24 fw-bold tab-block_titles text-center lyd-title-colo1 text-balck">{{ title }}</div>
        <p class="font-size-14 text-center tab-block_titles">{{ content }}</p>
      </div>
      <div class="item-list" data-aos="fade-up" :class="{'item-list-3': type === 3}">
        <div class="item-block" v-for="(item, index) in itemList" :key="index">
          <img :src="item.img" alt="" />
          <div class="item-block-title fw-bold">{{ item.title }}</div>
          <div class="item-block-text">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    itemList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: 4,
    },
  },
}
</script>
<style lang="scss"></style>
